var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPendingActions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "184 -823.39 655.38 687.39",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M687.16-136q-63.62 0-107.7-44.3-44.08-44.31-44.08-107.93t44.31-107.69Q623.99-440 687.61-440t107.7 44.3q44.07 44.31 44.07 107.93t-44.3 107.69Q750.78-136 687.16-136m54.46-69.92 27.84-27.85-62.69-62.69v-82.92H668v99.84zm-501 21.92q-23.55 0-40.09-16.53Q184-217.07 184-240.62v-478.76q0-23.55 16.53-40.09Q217.07-776 240.62-776h189.46q2.61-19.46 15.42-33.42 12.81-13.97 34.5-13.97 20.15 0 33.35 13.97 13.19 13.96 15.8 33.42h190.23q23.55 0 40.09 16.53Q776-742.93 776-719.38v225.76q-9.31-3.3-16.04-6.8T744-505.08v-214.3q0-9.24-7.69-16.93T719.38-744H632v89.23H328V-744h-87.38q-9.24 0-16.93 7.69T216-719.38v478.76q0 10.77 6.92 17.7 6.93 6.92 17.7 6.92h235.39q2.84 10.23 5.22 16.85 2.39 6.61 8.23 15.15zm239.17-550.77q12.13 0 20.33-7.98 8.19-7.98 8.19-20.12 0-12.13-7.98-20.32-7.99-8.19-20.12-8.19t-20.33 7.98q-8.19 7.98-8.19 20.11 0 12.14 7.98 20.33 7.99 8.19 20.12 8.19"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingActions);
export default __webpack_public_path__ + "static/media/pending_actions.11d1c98974878b85ed5db58d9cd1ff99.svg";
export { ForwardRef as ReactComponent };